import React from "react";

const ClockOutPing = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle
            cx={17.906}
            cy={28.241}
            r={4.937}
            fill="#FF6961"
            stroke="#fff"
            strokeWidth={1.646}
        />
        <path
            fill="#fff"
            stroke="#C8CBD8"
            strokeWidth={0.727}
            d="m25.36 20.36-7.454 7.454-7.455-7.454c-4.117-4.117-4.117-10.792 0-14.909 4.117-4.117 10.792-4.117 14.909 0 4.117 4.117 4.117 10.792 0 14.909Z"
        />
        <path
            fill={fill || "#FF6961"}
            d="M26.818 12.71a8.912 8.912 0 1 1-17.825 0 8.912 8.912 0 0 1 17.825 0Z"
        />
        <path
            fill="#fff"
            d="M17.958 17.913c-2.878 0-5.212-2.32-5.212-5.181 0-2.862 2.333-5.181 5.212-5.181 2.878 0 5.212 2.32 5.212 5.18 0 2.862-2.334 5.182-5.212 5.182Zm0-1.037c2.303 0 4.17-1.855 4.17-4.144 0-2.29-1.867-4.145-4.17-4.145s-4.17 1.856-4.17 4.145c0 2.289 1.867 4.145 4.17 4.145Zm.521-4.144h2.085v1.036h-3.127V10.14h1.042v2.59Z"
        />
    </svg>
);

export default ClockOutPing;
